import { Component, OnInit, forwardRef, ChangeDetectorRef, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormGroup, FormBuilder, AbstractControl, ValidationErrors, ControlValueAccessor, Validator, Validators, FormControl } from '@angular/forms';
import { FeesEstimate } from '../fees-estimation-request/fees-estimate.model';
import { GenericLookup } from 'src/app/front-user/shared/models/generic-lookup.model';
import { Languages, ShipGasType, YesNoOptions, ShipStatus, FormMode } from 'src/app/shared/models/enums.model';
import { User } from 'src/app/front-user/shared/models/user.model';
import { TranslateService } from '@ngx-translate/core';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { FeesEstimationService } from '../fees-estimation-request/fees-estimation.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { ActivatedRoute } from '@angular/router';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { first } from 'rxjs/operators';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { AgentService } from '../shared/services/agent.service';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { AppConfig } from 'src/app/shared/services/app.config';
import { SailDirection } from 'src/app/front-user/shared/models/sail-direction.model';

import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-fees-estimation-details',
  templateUrl: './fees-estimation-details.component.html',
  styleUrls: ['./fees-estimation-details.component.css'],
  providers: [
    DatePipe,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FeesEstimationDetailsComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => FeesEstimationDetailsComponent),
      multi: true
    }
  ]
})
export class FeesEstimationDetailsComponent implements OnInit, ControlValueAccessor, Validator {
  feesDetailsForm: FormGroup;
  feesEstimate: FeesEstimate = new FeesEstimate();
  formSubmitted = false;
  vesselTypes: GenericLookup[] = [];
  shipTypes: GenericLookup[] = [];
  militaryTypes: GenericLookup[] = [];
  shipmentTypes: GenericLookup[] = [];
  nationalities: GenericLookup[] = [];
  shipType: string;
  shipStatus = ShipStatus;
  shipStatusKeys = Object.keys(this.shipStatus);
  moreInfomation: string;
  options = YesNoOptions;
  yesNoOptionKeys = Object.keys(this.options);
  shipGasType = ShipGasType;
  shipGasTypeKeys = Object.keys(this.shipGasType);
  displayedLang: any;
   ShowGas: boolean = false;

  formatedTranistDate : any;

  formatedExpirationDate : any;
  OtherShimpentType = AppConfig.settings.apiServer.OtheShipmentType;
  public FloorsNumber: GenericLookup[] = [
    { Id: 1, NameEN: '1', NameAR: '١' },
    { Id: 2, NameEN: '2', NameAR: '٢' },
    { Id: 3, NameEN: '3', NameAR: '٣' },
    { Id: 4, NameEN: '4', NameAR: '٤' },
    { Id: 5, NameEN: '5', NameAR: '٥' },
    { Id: 6, NameEN: '6', NameAR: '٦' },
    { Id: 7, NameEN: '7', NameAR: '٧' },
    { Id: 8, NameEN: '8', NameAR: '٨' },
    { Id: 9, NameEN: '9', NameAR: '٩' },
    { Id: 10, NameEN: '10', NameAR: '١٠' },
    { Id: 11, NameEN: '11', NameAR: '١١' },
    { Id: 12, NameEN: '12', NameAR: '١٢' },
  ];
  public Languages: any = Languages;
  showPassengers: boolean = false;
  shipStatuses: any;
  showShipmentQuantity: boolean = false;
  showMilitaryShipment: boolean = false;
  ShowFloors: boolean = false;
  showFloat: boolean = false;
  ShowRoof: boolean = false;
  user: User = new User();
  numberDecimalRegex: string = '^[0-9]+(\\.?[0-9]+)?$';
  numberRegex: any = /^[0-9]*$/;
  showRequest = false;
  error: any = { isError: false, errorMessage: '' };
  errorTransitDate: any = { isError: false, errorMessage: '' };
  feesRequestId: string;
  responseObj: ResponseObject;
  agentId: string = '';
  responseObject: ResponseObject;
  selectedCurrency: string;
  agentCurrency: any;
  getFeesEstimateObj: FeesEstimate = new FeesEstimate();
  @Output() FeesEstimateObj = new EventEmitter<FeesEstimate>();
  @Input() FeesRequestId: string;
  isTabOneSubmitted: boolean = false;
  @Input() public TransitTabs: TabsetComponent;
  @Output() isTabOneValid = new EventEmitter<boolean>(false);
  @Input() public FormMode: number;
  @ViewChild('tabOneControls',{static: false}) tabOneControls: ElementRef;
  bsValue: Date;
  showShipmentOther: boolean= false;

  OtherVesselType = AppConfig.settings.apiServer.OtherVesselType;
  showVesselOther: boolean = false;
  directions: SailDirection[] = [];
  constructor(private datePipe: DatePipe,private formBuilder: FormBuilder,
    private lookupService: LookupService,
    private translate: TranslateService,
    private globalSrv: GlobalServices, private cd: ChangeDetectorRef,
    private feesEstimationService: FeesEstimationService,
    private alertService: AlertService,
    private authSrevice: AuthenticationService, private route: ActivatedRoute,
    private baseRequestService: BaseRequestService, private agentService: AgentService) {
    this.user = this.authSrevice.currentUserValue;
    this.shipStatusKeys = this.shipStatusKeys.slice(this.shipStatusKeys.length / 2);
    this.yesNoOptionKeys = this.yesNoOptionKeys.slice(this.yesNoOptionKeys.length / 2);
    this.shipGasTypeKeys = this.shipGasTypeKeys.slice(this.shipGasTypeKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage();


    // this.feesRequestId = 'FDF22A76-0DC7-44AE-BC6C-3AF6C2C91BD4';
    //this.getFeesRequest();
  }

  ngOnInit() {

    if (this.FeesRequestId) {
      this.feesRequestId = this.FeesRequestId;
      this.getFeesRequest();
    }
    this.buildForm();
    this.bsValue = new Date();
    this.getLookupsWithDeleted();
  }

  private getLookupsWithDeleted() {
    this.lookupService.getSailDirections().subscribe(d => {
      this.directions = d.Data;
    });
    this.lookupService.GetShipTypes().subscribe(d => {
      this.shipTypes = d.Data;
    });
    this.lookupService.GetShipmentTypes().subscribe(d => {
      this.shipmentTypes = d.Data;
    });
    this.lookupService.GetMilitaryShipmentTypes().subscribe(d => {
      this.militaryTypes = d.Data;
    });

    this.lookupService.GetNationality().subscribe(d => {
      this.nationalities = d.Data;
    });
  }
  buildForm() {
    this.feesDetailsForm = this.formBuilder.group({
      VesselName: new FormControl({ value: '', disabled: true }),
      SCID: new FormControl({ value: '', disabled: true }),
      CallSign: new FormControl({ value: '', disabled: true }),
      ShipTypeId: new FormControl({ value: '', disabled: true }),
      VesselTypeOther: new FormControl({ value: '', disabled: true }),
      ShipStatus: new FormControl({ value: '', disabled: true }),
      PassengersNumber: new FormControl({ value: '', disabled: true }),
      ShipmentTypeId: new FormControl({ value: '', disabled: true }),
      ShipmentQuantity: new FormControl({ value: '', disabled: true }),
      IsMilitaryShip: new FormControl({ value: '', disabled: true }),
      MilitaryShipmentTypeId: new FormControl({ value: '', disabled: true }),
      MilitaryShipmentQuantity: new FormControl({ value: '', disabled: true }),
      IsRoofFloatingUnits: new FormControl({ value: '', disabled: true }),
      TotalSuezAmount: new FormControl({ value: '', disabled: true }),
      FloatingUnitHeight: new FormControl({ value: '', disabled: true }),
      FloatingUnitWidth: new FormControl({ value: '', disabled: true }),
      FloatingUnitLength: new FormControl({ value: '', disabled: true }),
      IsEmptyConatiners: new FormControl({ value: '', disabled: true }),
      FloorsNumber: new FormControl({ value: '', disabled: true }),
      IsRoofContainers: new FormControl({ value: '', disabled: true }),
      RoofContainerFloorsNumber: new FormControl({ value: '', disabled: true }),
      IsGasShip: new FormControl({ value: '', disabled: true }),
      GasType: new FormControl({ value: '', disabled: true }),
      GazAmount: new FormControl({ value: '', disabled: true }),
      ShipNationalityId: new FormControl({ value: '', disabled: true }),
      Height: new FormControl({ value: '', disabled: true }),
      Width: new FormControl({ value: '', disabled: true }),
      TotalSuezCanalAmout: new FormControl({ value: '', disabled: true }),
      SuezCanalNetTonnage: new FormControl({ value: '', disabled: true }),
      ETA: new FormControl('', [Validators.required, CustomValidators.dateValidator()]),
      ETATime: new FormControl(new Date(), [Validators.required]),
      ArrivalDate: new FormControl({ value: '', disabled: true }),
      TransitDate: new FormControl('', [Validators.required, CustomValidators.dateValidator()]),
      LastTransitDate: new FormControl({ value: '', disabled: true }),
      GraveMaterial: new FormControl({ value: '', disabled: true }),
      SubmersibleAccess: new FormControl({ value: '', disabled: true }),
      Flake: new FormControl({ value: '', disabled: true }),
      Scouts: new FormControl({ value: '', disabled: true }),
      ComingFrom: new FormControl({ value: '', disabled: true }),
      DestinedTo: new FormControl({ value: '', disabled: true }),
      name: new FormControl({ value: '', disabled: true }),
      Phone1: new FormControl({ value: '', disabled: true }),
      SelectedCurrency: new FormControl({ value: '', disabled: true }),
      ShipmentOther:  new FormControl({ value: '', disabled: true }),
      DirectionId:  new FormControl({ value: '', disabled: true }),
    });
  }

  get f() {
    return this.feesDetailsForm.controls;
  }


  //#region CVA starts

  public onTouched: () => void = () => { };

  writeValue(val: any): void {
    val && this.feesDetailsForm.setValue(val, { emitEvent: false });
  }
  registerOnChange(fn: any): void {
    this.feesDetailsForm.valueChanges.subscribe(fn);
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.feesDetailsForm.disable() : this.feesDetailsForm.enable();
  }

  validate(c: AbstractControl): ValidationErrors | null {
    //return this.agentForm.valid ? null : { invalidForm: {valid: false, message: "agent form fields are invalid"}};
    return this.feesDetailsForm.valid ? null : this.feesDetailsForm.controls;
  }
  //#endregion

  public getFeesRequest() {
    this.feesEstimationService.get(this.feesRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.getFeesEstimateObj = this.responseObj.Data;
          this.agentId = resObj.Data['RequestorId'];

          //this.agentSrv.filter(this.agentId);
          let currency = resObj.Data['Currency'];
          this.getAgent(this.agentId, currency);

          if (this.responseObj.Data['ShipTypeId'] == this.OtherVesselType) {
            this.showVesselOther = true;
          }
          if (this.responseObj.Data['ShipmentTypeId'] == this.OtherShimpentType) {
            this.showShipmentOther = true;
          }
          if (this.responseObj.Data['IsGasShip']) {
            this.ShowGas = true;
          }
           resObj.Data['IsGasShip'] = this.responseObj.Data['IsGasShip'] ? 1 : 0;
          if (this.FormMode == FormMode.Readonly) {
            this.FeesEstimateObj.emit(resObj.Data);
            this.feesDetailsForm.patchValue(resObj.Data);
            this.feesDetailsForm.patchValue({
              ETA:  resObj.Data['ArrivalDate'],
              ETATime: resObj.Data['ArrivalDate'],
              TransitDate:  resObj.Data['TransitDate'],
            });
            this.feesDetailsForm.disable();
            this.isTabOneValid.emit(true);
          }
          if (this.FormMode == FormMode.Add) {
            this.getFeesEstimateObj.TransitDate = null;
            this.getFeesEstimateObj.ArrivalDate = null;
            this.feesDetailsForm.patchValue(resObj.Data);
            this.isTabOneValid.emit(false);
          }

        }
      });
  }


  public getAgent(agentId: string, currency) {
    this.agentService.GetAgent(agentId).subscribe(
      (resObj: ResponseObject) => {

        this.responseObject = resObj;
        if (this.responseObject.Success) {
          this.feesDetailsForm.patchValue({
            name: resObj.Data['Name'],
            Phone1: resObj.Data['Phone1'],
          });

          this.agentCurrency = resObj.Data['AgentCurrencies'];
          this.getCurrencyWithTreasury(currency, this.agentCurrency);
        }
      });
  }

  getCurrencyWithTreasury(currency: any, AgentCurrencies: any) {
    var selectCurrency = AgentCurrencies.filter(p => p.CurrencyId == currency.Id);
    if (this.displayedLang == Languages.English) {
      this.selectedCurrency = currency.NameEN + "-" + selectCurrency[0].TreasuryNumber;
      this.feesDetailsForm.patchValue({ SelectedCurrency: this.selectedCurrency });
    }
    else {
      this.selectedCurrency = currency.NameAR + "-" + selectCurrency[0].TreasuryNumber;
      this.feesDetailsForm.patchValue({ SelectedCurrency: this.selectedCurrency });
    }



  }

  compareTwoDates() {

    if (this.FormMode == FormMode.Add) {

      this.formatedExpirationDate=this.datePipe.transform(this.getFeesEstimateObj.ExpirationDate, "yyyy-MM-dd");
      this.error = { isError: false, errorMessage: '' };
      this.errorTransitDate = { isError: false, errorMessage: '' };
      this.feesDetailsForm.controls.ETA.setErrors(null);
      this.feesDetailsForm.controls.TransitDate.setErrors(null);
      if ((this.feesDetailsForm.controls['ETA'].value && this.feesDetailsForm.controls['TransitDate'].value) &&
        new Date(this.feesDetailsForm.controls['TransitDate'].value) < new Date(this.feesDetailsForm.controls['ETA'].value)) {
        this.error = { isError: true, errorMessage: this.translate.instant('FRONT_USER.FEES_ESTIMATION_FORM.COMPARE_DATES_ERROR') };
        this.feesDetailsForm.controls.ETA.setErrors({ 'invalid': true });
        this.isTabOneValid.emit(false);
      }
     if (this.feesDetailsForm.controls['TransitDate'].value) {
      let formatedExpirationDateString=this.datePipe.transform(this.getFeesEstimateObj.ExpirationDate, "yyyy-MM-dd");
      let formatedTransitDate=this.datePipe.transform(this.feesDetailsForm.controls['TransitDate'].value, "yyyy-MM-dd");
        if (Date.parse(formatedTransitDate) > Date.parse(formatedExpirationDateString)) {
           this.errorTransitDate = { isError: true, errorMessage: this.translate.instant('FRONT_USER.FEES_ESTIMATION_FORM.COMPARE_TRANSIT_EXPIRE_DATES_ERROR') };
          this.feesDetailsForm.controls.TransitDate.setErrors({ 'invalid': true });
          this.isTabOneValid.emit(false);
        }
        else {
          this.errorTransitDate = { isError: false, errorMessage: '' };
          this.feesDetailsForm.get('TransitDate').setValidators([Validators.required, CustomValidators.dateValidator]);
          this.feesDetailsForm.get('TransitDate').updateValueAndValidity();
           this.validateTabOne;
        }
      }
      else {
        this.error = { isError: false, errorMessage: '' };
        this.errorTransitDate = { isError: false, errorMessage: '' };
        this.feesDetailsForm.controls.ETA.setValidators([Validators.required, CustomValidators.dateValidator]);
        this.feesDetailsForm.controls.ETA.updateValueAndValidity();
        this.feesDetailsForm.controls.TransitDate.setValidators([Validators.required, CustomValidators.dateValidator]);
        this.feesDetailsForm.controls.TransitDate.updateValueAndValidity();
        this.validateTabOne;
      }
    }
  }

  selectTab(tabId: number) {
    if (tabId == 1) {
      this.isTabOneSubmitted = true;
      if (!this.validateTabOne) {
        this.isTabOneValid.emit(true);
        this.TransitTabs.tabs[tabId].disabled = false;
        this.TransitTabs.tabs[tabId].active = true;
        const el = document.getElementsByClassName('section-title');
        el[0].scrollIntoView({ behavior: 'smooth' });
      }
      else {
        const invalidControls = this.tabOneControls.nativeElement.querySelectorAll('.ng-invalid');
        if (invalidControls.length > 0) {
          invalidControls[0].focus();
        }
        this.TransitTabs.tabs[tabId].disabled = true;
        this.TransitTabs.tabs[tabId].active = false;
      }
    }

  }



  get validateTabOne() {
    const isvalid = this.feesDetailsForm.controls['ETA'].invalid
      || this.feesDetailsForm.controls['ETATime'].invalid
      || this.feesDetailsForm.controls['TransitDate'].invalid
    if (isvalid) {
      this.isTabOneValid.emit(false);
    }
    else {
      this.isTabOneValid.emit(true);
    }
    return isvalid;

  }

}
